<pm-dialog
  dialogTitle="Widget View konfigurieren"
  class="min-w-[80vw] h-[80vh]"
  contentClass="gap-8 space-y-2"
  [primaryCtaButtonConfig]="buttonConfig.submitButton"
  [secondaryCtaButtonConfig]="buttonConfig.cancelButton"
>
  <div
    cdkDropList
    cdkDropListOrientation="mixed"
    class="grid grid-cols-2 w-full gap-4"
    (cdkDropListDropped)="drop($event)"
  >
    @for (widget of widgets; track $index) {
      <div
        cdkDrag
        class="border rounded-md bg-background flex flex-col gap-2 p-4 group relative min-h-96"
        (cdkDragStarted)="this.isDragging = true"
        (cdkDragEnded)="this.isDragging = false"
      >
        <p
          class="w-full border border-primary rounded-lg cursor-pointer bg-slate-50 flex flex-col gap-2 px-4 py-2 text-center justify-center items-center italic text-sm"
          *cdkDragPlaceholder
        >
          Neue Widget-Position
        </p>
        <div *cdkDragPreview>
          <mat-form-field
            class="flex flex-row flex-1"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <mat-label>Widget</mat-label>
            <ngx-virtual-select-field
              placeholder="Widget auswählen"
              [multiple]="false"
              (valueChange)="changedWidgetType($event, $index)"
            >
              <ngx-virtual-select-field-option
                *ngxVirtualSelectFieldOptionFor="
                  let supportedWidget of this.supportedWidgetOptions
                "
                [value]="supportedWidget.value"
              >
                {{ supportedWidget.label }}
              </ngx-virtual-select-field-option>
            </ngx-virtual-select-field>
          </mat-form-field>
        </div>
        <div class="flex flex-row gap-4">
          <div class="flex flex-col flex-grow">
            <mat-form-field class="flex flex-row flex-1" appearance="outline">
              <mat-label>Name</mat-label>
              <input
                matInput
                type="text"
                [value]="widget.name || ''"
                (change)="changedWidgetName($event, $index)"
              />
            </mat-form-field>
            <mat-form-field
              class="flex flex-row flex-1"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-label>Widget</mat-label>
              <ngx-virtual-select-field
                placeholder="Widget auswählen"
                [value]="widget.type || 'PLACEHOLDER'"
                [multiple]="false"
                (valueChange)="changedWidgetType($event, $index)"
              >
                <ngx-virtual-select-field-option
                  *ngxVirtualSelectFieldOptionFor="
                    let supportedWidget of this.supportedWidgetOptions
                  "
                  [value]="supportedWidget.value"
                >
                  {{ supportedWidget.label }}
                </ngx-virtual-select-field-option>
              </ngx-virtual-select-field>
            </mat-form-field>
          </div>
          <div
            class="flex flex-col justify-center cursor-pointer"
            cdkDragHandle
          >
            <pm-icon [icon]="dragIcon" size="md"></pm-icon>
          </div>
        </div>

        <mat-divider />
        <div class="flex flex-col gap-4 w-full">
          <p class="underline">Konfigurationsmöglichkeiten</p>
          @switch (widget.type) {
            @case (WidgetType.SINGLE_FORECASTS) {
              <div class="flex flex-col gap-4">
                <pm-resolution-picker
                  [resolution]="widget.resolution"
                  (resolutionChange)="changeResolution($event, $index)"
                />
                <pm-target-unit-picker
                  [showWarningMessageForNoMultipleTargetUnit]="true"
                  [skipTargetUnitUrlUpdate]="true"
                  [targetUnit]="widget.targetUnit"
                  (targetUnitChange)="changeTargetUnit($event, $index)"
                />

                <!-- filter -->
                <mat-form-field
                  color="primary"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>
                    {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
                  </mat-label>

                  <ngx-virtual-select-field
                    [value]="widget.filterColumn"
                    (valueChange)="
                      changeSingleForecastsFilter(
                        $event,
                        $index,
                        'filterColumn'
                      )
                    "
                  >
                    <ngx-virtual-select-field-option
                      *ngxVirtualSelectFieldOptionFor="
                        let option of this.availableFiltersOptions()
                      "
                      [value]="option.value"
                      >{{ option.label }}
                    </ngx-virtual-select-field-option>
                  </ngx-virtual-select-field>
                </mat-form-field>

                <!-- filter options -->
                <mat-form-field
                  color="primary"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>
                    {{ 'RESULT.INSIGHTS.GENERAL.SELECT_DATASET' | translate }}
                  </mat-label>

                  <ngx-virtual-select-field
                    multiple
                    allowSearchField="true"
                    [value]="widget.filterOptions"
                    (valueChange)="
                      changeSingleForecastsFilter(
                        $event,
                        $index,
                        'filterOptions'
                      )
                    "
                  >
                    <ngx-virtual-select-field-option
                      *ngxVirtualSelectFieldOptionFor="
                        let filterOption of getFilterOptionsOfFilterColumnSingleForecast(
                          $index
                        )
                      "
                      [value]="filterOption.value"
                      >{{ filterOption.label }}
                    </ngx-virtual-select-field-option>
                  </ngx-virtual-select-field>
                </mat-form-field>
              </div>
            }
            @case (WidgetType.PORTFOLIO_TOTALS) {
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />

              <!-- filter -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
                </mat-label>

                <ngx-virtual-select-field
                  [value]="widget.filter"
                  (valueChange)="
                    changePortfolioTotalsSettings($event, $index, 'filter')
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let option of this.availableFiltersOptionsForPortfolioTotals()
                    "
                    [value]="option.value"
                    >{{ option.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>

              <!-- year -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_YEAR' | translate }}
                </mat-label>
                <ngx-virtual-select-field
                  (valueChange)="
                    changePortfolioTotalsSettings($event, $index, 'year')
                  "
                  [value]="widget.year"
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let year of possibleYearsOptions()
                    "
                    [value]="year.value"
                  >
                    {{ year.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>
            }
            @case (WidgetType.PORTFOLIO_TOTALS_MULTI_YEAR) {
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />

              <!-- filter -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
                </mat-label>

                <ngx-virtual-select-field
                  [value]="widget.filter"
                  (valueChange)="
                    changePortfolioTotalsMultiYearSettings(
                      $event,
                      $index,
                      'filter'
                    )
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let option of this.availableFiltersOptions()
                    "
                    [value]="option.value"
                    >{{ option.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>

              <!-- years -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_YEARS' | translate }}
                </mat-label>
                <ngx-virtual-select-field
                  [value]="widget.years"
                  multiple
                  (valueChange)="
                    changePortfolioTotalsMultiYearSettings(
                      $event,
                      $index,
                      'years'
                    )
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let option of possibleYearsOptions()
                    "
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>
            }
            @case (WidgetType.YEAR_TO_DATE_TREND) {
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />

              <!-- filter -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
                </mat-label>

                <ngx-virtual-select-field
                  [value]="widget.filterColumn"
                  (valueChange)="
                    changeYearToDateFilter($event, $index, 'filterColumn')
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let filterName of this.availableFiltersOptions()
                    "
                    [value]="filterName.value"
                    >{{ filterName.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>

              <!-- filter options -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_DATASET' | translate }}
                </mat-label>

                <ngx-virtual-select-field
                  multiple
                  [value]="widget.filterOptions"
                  (valueChange)="
                    changeYearToDateFilter($event, $index, 'filterOptions')
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let filterOption of getFilterOptionsOfFilterColumnTrendAnalysis(
                        $index
                      )
                    "
                    [value]="filterOption.value"
                    >{{ filterOption.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>
            }
            @case (WidgetType.YEARLY_COMPARISON) {
              <pm-resolution-picker
                [resolution]="widget.resolution"
                (resolutionChange)="changeResolution($event, $index)"
              />
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />
              <!-- filter -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
                </mat-label>
                <ngx-virtual-select-field
                  [value]="widget.filterColumn"
                  (valueChange)="
                    changeYearlyComparisonConfiguration(
                      $event,
                      $index,
                      'filterColumn'
                    )
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let option of this.availableFiltersOptions()
                    "
                    [value]="option.value"
                    >{{ option.label }}
                  </ngx-virtual-select-field-option>
                  <ngx-virtual-select-field-option [value]="TOTALS"
                    >{{ TOTALS }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>
              <!-- filter options -->
              <mat-form-field
                color="primary"
                appearance="outline"
                subscriptSizing="dynamic"
              >
                <mat-label>
                  {{ 'RESULT.INSIGHTS.GENERAL.SELECT_DATASET' | translate }}
                </mat-label>
                <ngx-virtual-select-field
                  [value]="widget.filterOptions"
                  (valueChange)="
                    changeYearlyComparisonConfiguration(
                      $event,
                      $index,
                      'filterOptions'
                    )
                  "
                >
                  <ngx-virtual-select-field-option
                    *ngxVirtualSelectFieldOptionFor="
                      let filterOption of getFilterOptionsOfFilterColumnYearlyComparison(
                        $index
                      )
                    "
                    [value]="filterOption.value"
                    >{{ filterOption.label }}
                  </ngx-virtual-select-field-option>
                </ngx-virtual-select-field>
              </mat-form-field>
            }
            @case (WidgetType.PLANNING_ACCURACY) {
              <div class="flex flex-col gap-4">
                <!-- planning period -->
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>
                    {{
                      'RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.PLANNING_PERIOD'
                        | translate
                    }}
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    placeholder="1"
                    min="0"
                    [ngModel]="widget.planningPeriod"
                    (ngModelChange)="setPlanningPeriod($event, $index)"
                  />
                </mat-form-field>

                <pm-resolution-picker
                  [resolution]="widget.resolution"
                  (resolutionChange)="changeResolution($event, $index)"
                />

                <!-- filter group -->
                <mat-form-field
                  color="primary"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>
                    {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
                  </mat-label>

                  <ngx-virtual-select-field
                    [value]="widget.selectedFilterGroup"
                    (valueChange)="
                      changeDefaultFilterSelectionOfPlanningAccuracyWidget(
                        $event,
                        $index,
                        'selectedFilterGroup'
                      )
                    "
                  >
                    <ngx-virtual-select-field-option
                      *ngxVirtualSelectFieldOptionFor="
                        let filterName of this.availableFiltersOptions()
                      "
                      [value]="filterName.value"
                      >{{ filterName.label }}
                    </ngx-virtual-select-field-option>
                  </ngx-virtual-select-field>
                </mat-form-field>

                <!-- filter option -->
                <mat-form-field
                  color="primary"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>
                    {{ 'RESULT.INSIGHTS.GENERAL.SELECT_DATASET' | translate }}
                  </mat-label>

                  <ngx-virtual-select-field
                    [value]="widget.selectedFilterOption"
                    (valueChange)="
                      changeDefaultFilterSelectionOfPlanningAccuracyWidget(
                        $event,
                        $index,
                        'selectedFilterOption'
                      )
                    "
                  >
                    <ngx-virtual-select-field-option
                      *ngxVirtualSelectFieldOptionFor="
                        let filterOption of getFilterOptionsOfFilterGroupPlanningAccuracy(
                          $index
                        )
                      "
                      [value]="filterOption.value"
                      >{{ filterOption.label }}
                    </ngx-virtual-select-field-option>
                  </ngx-virtual-select-field>
                </mat-form-field>

                <!-- additional time series-->
                <mat-form-field
                  color="primary"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>
                    {{
                      'CONFIGURATION.FORM.DATASOURCE.ADDITIONAL_TIME_SERIES_NAMES'
                        | translate
                    }}
                  </mat-label>

                  <ngx-virtual-select-field
                    [value]="widget.additionalTimeSeriesName"
                    [disabled]="additionalTimeSeries.length === 0"
                    (valueChange)="
                      changeDefaultFilterSelectionOfPlanningAccuracyWidget(
                        $event,
                        $index,
                        'additionalTimeSeriesName'
                      )
                    "
                  >
                    <ngx-virtual-select-field-option
                      *ngxVirtualSelectFieldOptionFor="
                        let additionalTimeSeries of additionalTimeSeriesOptions()
                      "
                      [value]="additionalTimeSeries.value"
                      >{{ additionalTimeSeries.label }}
                    </ngx-virtual-select-field-option>
                  </ngx-virtual-select-field>
                </mat-form-field>
              </div>
            }
            @case (WidgetType.ABC_XYZ_ANALYSIS) {
              <!-- abc xyz analysis target-->
              <div class="flex flex-col gap-4">
                @if (configuration(); as configuration) {
                  <!-- ABC Limits -->
                  <mat-form-field
                    appearance="outline"
                    color="primary"
                    [pmTooltip]="'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.ABC_LIMITS_TOOLTIP'"
                  >
                    <mat-label>
                      {{
                        'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.ABC_LIMITS'
                          | translate
                      }}
                    </mat-label>
                    <input
                      matInput
                      placeholder="0.8,0.95"
                      [ngModel]="widget.volumeBinLimits"
                      (ngModelChange)="
                        setBinLimitsOfAbcXyzAnalysisWidget(
                          $event,
                          $index,
                          'volumeBinLimits'
                        )
                      "
                    />
                  </mat-form-field>

                  <!-- XYZ Limits -->
                  <mat-form-field
                    appearance="outline"
                    color="primary"
                    [pmTooltip]="'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.XYZ_LIMITS_TOOLTIP'"
                  >
                    <mat-label>
                      {{
                        'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.XYZ_LIMITS'
                          | translate
                      }}
                    </mat-label>
                    <input
                      matInput
                      placeholder="0.8,0.95"
                      [ngModel]="widget.forecastAccuracyBinLimits"
                      (ngModelChange)="
                        setBinLimitsOfAbcXyzAnalysisWidget(
                          $event,
                          $index,
                          'forecastAccuracyBinLimits'
                        )
                      "
                    />
                  </mat-form-field>

                  <!-- Grouping -->
                  <mat-form-field
                    color="primary"
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>
                      {{
                        'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.GROUPING'
                          | translate
                      }}
                    </mat-label>

                    <ngx-virtual-select-field
                      multiple
                      [value]="widget.groups"
                      [disabled]="
                        configuration.startForecastConfig.group_columns
                          ?.length === 0
                      "
                      (valueChange)="
                        changeDefaultFilterSelectionOfAbcXyzWidget(
                          $event,
                          $index,
                          'groups'
                        )
                      "
                    >
                      <ngx-virtual-select-field-option
                        *ngxVirtualSelectFieldOptionFor="
                          let option of startForecastConfigGroupColumnOptions()
                        "
                        [value]="option.value"
                        >{{ option.label }}
                      </ngx-virtual-select-field-option>
                    </ngx-virtual-select-field>
                  </mat-form-field>
                }
                <!-- planning period -->
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>
                    {{
                      'RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.PLANNING_PERIOD'
                        | translate
                    }}
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    placeholder="1"
                    min="1"
                    [(ngModel)]="widget.planningPeriod"
                    (ngModelChange)="setPlanningPeriod($event, $index)"
                  />
                </mat-form-field>

                <!-- error measure -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>
                    {{
                      'RESULT.KPIS.TITLE_BAR.ERROR_MEASURE_LABEL' | translate
                    }}</mat-label
                  >
                  <ngx-virtual-select-field
                    [value]="widget.errorMeasure"
                    [multiple]="false"
                    (valueChange)="
                      changeDefaultFilterSelectionOfAbcXyzWidget(
                        $event,
                        $index,
                        'errorMeasure'
                      )
                    "
                  >
                    <ngx-virtual-select-field-option
                      *ngxVirtualSelectFieldOptionFor="
                        let option of relativeErrorMeasureOptions
                      "
                      [value]="option.value"
                    >
                      {{ option.label | uppercase }}
                    </ngx-virtual-select-field-option>
                  </ngx-virtual-select-field>
                </mat-form-field>

                <!-- Limit time period + info tooltip -->
                <mat-form-field
                  appearance="outline"
                  color="primary"
                  [floatLabel]="'always'"
                  [pmTooltip]="'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.LIMIT_TIME_PERIOD_TOOLTIP'"
                >
                  <mat-label>
                    {{
                      'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.LIMIT_TIME_PERIOD'
                        | translate
                    }}
                  </mat-label>
                  <input
                    matInput
                    type="number"
                    [ngModel]="widget.timePeriodBackwardsInMonths"
                    (ngModelChange)="
                      setTimePeriodBackwardsInMonthsForAbcXyzAnalysisWidget(
                        $event,
                        $index
                      )
                    "
                  />
                  <span matSuffix>
                    {{ 'RESULT_OVERVIEW.HORIZON.MONTHS' | translate }}
                    &nbsp;
                  </span>
                </mat-form-field>

                <!-- target unit -->
                <pm-target-unit-picker
                  [showWarningMessageForNoMultipleTargetUnit]="true"
                  [skipTargetUnitUrlUpdate]="true"
                  [targetUnit]="widget.targetUnit"
                  (targetUnitChange)="changeTargetUnit($event, $index)"
                />
              </div>
            }

            @default {
              <p class="italic text-xs">
                Keine Konfigurationsmöglichkeiten vorhanden.
              </p>
            }
          }
        </div>
        <span
          class="absolute -bottom-4 -right-4 opacity-0 group-hover:opacity-100"
        >
          <pm-button
            variant="critical"
            [icon]="trashIcon"
            [pmTooltip]="'Widget entfernen'"
            (handleClick)="removeWidget($index)"
          />
        </span>
      </div>
    }

    <div
      class="col-span-1 flex items-center justify-center h-96 bg-slate-50 border rounded"
    >
      <pm-button
        variant="subdued"
        [icon]="plusIcon"
        (handleClick)="addWidget()"
        [pmTooltip]="'Widget hinzufügen'"
      />
    </div>
  </div>
</pm-dialog>
